import { Button } from "antd-mobile";

export default Button;
